const EventInputForms = ({ eventData, setEventData }) => {
  return (
    <div className={"grid gap-2"}>
      <div className={"grid gap-2"}>
        <label className="block text-sm font-medium text-gray-900">
          Εκκλησία
        </label>
        <input
          onChange={(e) =>
            setEventData((prevState) => ({
              ...prevState,
              meetingHouse: e.target.value,
            }))
          }
          value={eventData.meetingHouse}
          type="text"
          className="shadow-sm rounded-md w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          placeholder=""
          pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
          required
        />
      </div>

      <div className={"grid gap-2"}>
        <label className="block text-sm font-medium text-gray-900">
          Αριθμός ομιλίας
        </label>
        <input
          onChange={(e) =>
            setEventData((prevState) => ({
              ...prevState,
              number: e.target.value,
            }))
          }
          value={eventData.number}
          type="tel"
          className="shadow-sm rounded-md w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          placeholder=""
          pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
          required
        />
      </div>
      <div className={"grid gap-2"}>
        <label className="block text-sm font-medium text-gray-900">
          Τηλέφωνο επικοινωνίας
        </label>
        <input
          onChange={(e) =>
            setEventData((prevState) => ({
              ...prevState,
              contactPhone: e.target.value,
            }))
          }
          value={eventData.contactPhone}
          type="tel"
          className="shadow-sm rounded-md w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          placeholder=""
          pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
          required
        />
      </div>
    </div>
  );
};

export default EventInputForms;
